import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export class Parallax {
    constructor() {
        this._elements = document.querySelectorAll('[animation-parallax]');

        if (!this._elements.length) {
            return;
        }

        this.init();
    }

    init() {
        gsap.registerPlugin(ScrollTrigger);

        this._elements.forEach((el) => {
            const img = el.querySelector('img');
            if (!img) {
                return;
            }

            gsap.fromTo(
                img,
                { yPercent: -15 },
                {
                    yPercent: 15,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true
                    }
                }
            );
        });
    }
}
